/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TdbP1DonneesInstallationResponseDto } from '../../models/tdb-p-1-donnees-installation-response-dto';

export interface GetTdbDonneesInstallationP1$Params {
  dkCodeInstallation: string;
}

export function getTdbDonneesInstallationP1(
  http: HttpClient,
  rootUrl: string,
  params: GetTdbDonneesInstallationP1$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<TdbP1DonneesInstallationResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getTdbDonneesInstallationP1.PATH, 'get');
  if (params) {
    rb.path('dkCodeInstallation', params.dkCodeInstallation, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TdbP1DonneesInstallationResponseDto>;
    })
  );
}

getTdbDonneesInstallationP1.PATH = '/v1/reportings_p1/tdb/installation/{dkCodeInstallation}';
